
import RotateRight from "../../../assets/duotone/RotateRight.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RotateRightIcon({ className, dataTestid = "RotateRightIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <RotateRight data-testid={dataTestid} className={classes} {...rest} />
  );
}
